import { graphql } from "react-relay";
import { Environment } from "relay-runtime";

import {
  commitMutationPromiseNormalized,
  createMutation,
  MutationInput,
} from "coral-framework/lib/relay";

import { ApproveImageMutation as MutationTypes } from "coral-admin/__generated__/ApproveImageMutation.graphql";

let clientMutationId = 0;

const ApproveImageMutation = createMutation(
  "approveImage",
  (environment: Environment, input: MutationInput<MutationTypes>) =>
    commitMutationPromiseNormalized<MutationTypes>(environment, {
      mutation: graphql`
        mutation ApproveImageMutation($input: ApproveCommentImageInput!) {
          approveImage(input: $input) {
            comment {
              id
              images {
                id
                url
                status
                reasons
              }
              ...ModerateCardContainer_comment
            }
          }
        }
      `,
      variables: {
        input: {
          commentID: input.commentID,
          imageID: input.imageID,
          clientMutationId: (clientMutationId++).toString(),
        },
      },
    })
);

export default ApproveImageMutation;
